import { ThemeAppearance } from "@tandemdiabetes/sugarmate-api-react-client"
import type { ReactNode } from "react"
import { useEffect } from "react"

import { useFollowedUsers } from "src/contexts"
import styles from "src/styles/themeClasses.module.scss"

interface Props {
  children: ReactNode;
}

// this component applies the current theme to the body element
export function ThemeComponent(props: Props) {
  const { currentDeviceSettings } = useFollowedUsers()
  const currentTheme = currentDeviceSettings.theme
  const currentThemeAppearance = currentDeviceSettings.theme_appearance

  useEffect(
    () => {
      const className = currentThemeAppearance === ThemeAppearance.Light
        ? styles[`${currentTheme}Light`]
        : currentThemeAppearance === ThemeAppearance.Dark
          ? styles[`${currentTheme}Dark`]
          : styles[currentTheme]

      document.body.classList.add(className)

      return () => {
        document.body.classList.remove(className)
      }
    },
    [
      currentTheme,
      currentThemeAppearance,
    ],
  )

  return (
    <>
      {props.children}
    </>
  )
}
